import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Button from '../Button/Button';
import Group from '../Group/Group';
import Languagebar from '../Languagebar/Languagebar';
import Menu from '../Menu/Menu';
import TabbedLightbox from './TabbedLightbox';
import Tabs from '../Tabs/Tabs';
import TransitionGroup from '../TransitionGroup/TransitionGroup';

const LOCALES = [
  { localeId: 'ar_AE', language: 'Arabic', country: 'United Arab Emirates' },
  { localeId: 'de_DE', language: 'German', country: 'Germany' },
  { localeId: 'en_US', language: 'English', country: 'United States', default: true },
  { localeId: 'es_ES', language: 'Spanish', country: 'Spain' },
  { localeId: 'no_NB', language: 'Norwegian', country: 'Norway' },
  { localeId: 'pt_PT', language: 'Portuguese', country: 'Portugal' },
];

class TabbedLightboxExample extends Component {

  constructor(props) {
    super(props);
    this.state = {
      cover: 'https://images-na.ssl-images-amazon.com/images/M/MV5BMTA1ODgxNDAwNDVeQTJeQWpwZ15BbWU4MDIxMjg1NzIx._V1_SY1000_CR0,0,1422,1000_AL_.jpg',
      id: '1EDgqLEdWrmR',
      fields: [
        {
          name: 'Created',
          value: '2017-01-10 09:17:00',
        }, {
          name: 'Last Updated',
          value: '2017-01-11 11:30:12',
        }, {
          name: 'Duration',
          value: '00:00:00',
        },
      ],
      title: 'Trump Attempts Campaign Reboot as More Republicans Abandon Him',
    };
  }

  onChange = e => this.setState(e.target.value);

  onChangeTab = (e, index, name) => {
    window.showAppInfo(name);
    this.setState({ selected: index });
  };

  onClick = e => {
    this.setState({ open: true });
    setTimeout(() => {
      this.forceUpdate();
    }, 0);
  };

  onClose = e => this.setState({ open: false });

  render() {
    const { open, ...rest } = this.state;

    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={TabbedLightbox.defaultProps} propTypes={TabbedLightbox.propTypes} propValues={this.state}/>
        <div className="trigger-buttons">
          <Button onClick={this.onClick}>Open Lightbox</Button>
          <Menu buttonClass="core-icon-button">
            <Button onClick={this.onClick} iconName="edit">Edit</Button>
          </Menu>
        </div>
        <SourceCode querySelector=".core-lightbox" title="Generated HTML (expand and click open lightbox)"/>
        <TransitionGroup in={open} className="animate-lightbox">
          <TabbedLightbox {...rest} onClose={this.onClose} onChange={this.onChangeTab}>
            <Group name="General">
              <Languagebar locales={LOCALES} visible={[LOCALES[0], LOCALES[1], LOCALES[2]]} selected={LOCALES[0]}/>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
              <Tabs>
                <div name="First">
                  <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                  <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                </div>
                <div name="Second">
                  <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                </div>
              </Tabs>
            </Group>
            <Group name="List Type">
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
              <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            </Group>
            <Group name="Images">
              <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
              <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            </Group>
            <Group name="Highlights Reel">
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
              <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
              <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
              <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
              <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
              <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
            </Group>
          </TabbedLightbox>
        </TransitionGroup>
      </Example>
    );
  }

}

TabbedLightboxExample.tags = 'dialog modal';

export default TabbedLightboxExample;
